var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.field)?_c('Field',{key:"field",attrs:{"name":_vm.field.name,"schema":{
    type: _vm.field.type,
    label: _vm.schema.label,
    fieldOptions: _vm.field.options
  },"environment-variables":_vm.environmentVariables},model:{value:(_vm.fieldValue),callback:function ($$v) {_vm.fieldValue=$$v},expression:"fieldValue"}}):_c('div',{staticStyle:{"height":"100%","display":"flex"}},[_c('span',{key:"noField",staticStyle:{"margin-top":"auto","margin-bottom":"5px"},attrs:{"id":"primero"}},[_vm._v(_vm._s(_vm.$t('fieldOptions_field.select')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }